import { Typography } from '@cobliteam/ui/components';
import Link from '@cobliteam/ui/components/Link';

import ExamplePrompt from './components/ExamplePrompt';

import coblinatorLogo from '../../resources/coblinatorLogo.webp';

interface LandingContentProps {
  onPromptClick: (prompt: string) => void;
}

const LandingContent = ({ onPromptClick }: LandingContentProps) => (
  <div className='flex flex-col gap-8'>
    <div className='flex flex-col items-center justify-center gap-3'>
      <div>
        <img src={coblinatorLogo} />
      </div>
      <Typography variant='heading-1'>Pergunte ao Coblinator</Typography>
      <Typography className='text-center' color='secondary'>
        Para uma resposta precisa, elabore a pergunta fornecendo detalhes específicos sobre datas, veículos ou motoristas envolvidos, e outras informações relevantes.
        <br />
        Saiba como fazer melhores perguntas
        <Link size='sm' href='https://suporte.cobli.co/resumo-de-trajetos-e-paradas' target='_blank' rel='noopener noreferrer' className='ml-1'>
          aqui
        </Link>
        .
      </Typography>
    </div>
    <ExamplePrompt onPromptClick={onPromptClick} />
  </div>
);

export default LandingContent;
